module.exports = __webpack_public_path__ + "static/fast-breadcrumb-icon-9fc67a191204ca038510ab5973f10185.png";